export type QuizStatus = "draft" | "published";

export type QuestionType =
  | "quiz_single"
  | "quiz_multi"
  | "true_false"
  | "type_answer"
  | "slide";

export interface AnswerOption {
  id: string;
  label: string;
  isCorrect: boolean;
  orderIndex: number;
}

export interface Question {
  id: string;
  type: string;
  prompt: string | null;
  timerSeconds: number;
  imageAssetId?: string | null;
  answerOptions: AnswerOption[];
  acceptedAnswers?: Array<{ id?: string; normalizedValue: string }>;
}

export interface Quiz {
  id: string;
  title: string;
  /** Mirrors the API exactly; there is no derived `status` field on the wire. */
  isPublished: boolean;
  questionCount?: number;
}

export interface QuizWithQuestions extends Quiz {
  description?: string | null;
  questions: Question[];
}

export interface QuizDraft {
  type: QuestionType;
  prompt?: string;
  timerSeconds: number;
  options: { label: string; isCorrect: boolean }[];
  acceptedAnswers?: { normalizedValue: string }[];
  imageAssetId?: string;
}

export const QUESTION_TYPE_LABELS: Record<QuestionType, string> = {
  quiz_single: "Single answer",
  quiz_multi: "Multiple answers",
  true_false: "True or false",
  type_answer: "Type answer",
  slide: "Slide",
};

export const MIN_TIMER_SECONDS = 5;
export const MAX_TIMER_SECONDS = 120;
export const DEFAULT_TIMER_SECONDS = 20;
export const MIN_OPTIONS = 2;
export const MAX_OPTIONS = 4;
